import Vue from "vue"
import Vuetify from "vuetify/lib"
import "vuetify/dist/vuetify.min.css"
import "@mdi/font/css/materialdesignicons.css"
import ja from "vuetify/src/locale/ja"

Vue.use(Vuetify)

export default new Vuetify({
  iconfont: "mdi",
  lang: { locales: { ja }, current: "ja" },
})
